'use client'

import {
	useCommentModal,
	useAppNavigationBar,
	useInterfaceCommentTotalCount,
} from '@providers/_hooks'
import type { PropsWithChildren } from 'react'

interface NewsInterfaceProviderProps extends PropsWithChildren {}

const NewsInterfaceProvider = ({ children }: NewsInterfaceProviderProps) => {
	useCommentModal()
	useAppNavigationBar()
	useInterfaceCommentTotalCount()

	return <>{children}</>
}
export default NewsInterfaceProvider
